
let reduxStore = null;

/**
 * [setReduxStore description]
 * 
 * @param {[type]} store [description]
 */
export function setReduxStore( store ) {
    reduxStore = store;
}

/**
 * [getReduxStore description]
 * 
 * @return {[type]} [description]
 */
export function getReduxStore() {
    return reduxStore;
}

/**
 * [reduxGetState description]
 * 
 * @return {[type]} [description]
 */
export function reduxGetState() {
    if ( ! reduxStore ) {
        return;
    }
    return reduxStore.getState();
}